/**
 * Created by broturne on 1/4/16.
 */
define(['site/Components/Shared/Helper'], function (helper) {
    var HeaderNav = {
        toggle: null,
        header: null,
        panelBtn: null,
        search: null,
        closeBtn: null,
        Init: function () {
            //declare vars
            this.header = document.querySelector('.score-header');
            this.toggle = document.querySelector('.navbar-toggle');
            this.panelBtn = document.querySelectorAll('.tek-collapsible-panel-button'); //once code is modified this will need to change
            this.search = document.querySelectorAll('.tek-collapsible-panel-button');
            this.closeBtn = document.querySelectorAll('.panel-collapse .btn--close');
            this.vnnMenu = document.querySelector("#vnn-mobile-menu");
            this.vnnToggle = document.querySelector('[data-target="#vnn-mobile-menu"]');

            //add/remove class to score-header on open menu
            this.clicked();
            this.closePanel();
            this.searchOpen();
            this.langOpen();
            this.panelBtnClose();
            this.generateListItem();
            this.onClosed();
            this.setupCloseSubMenu();
            this.closeMobileMenuClickOutside();
            this.setupMenuToggle();
        },

        setupMenuToggle: function () {
            var self = this;

            this.toggle?.addEventListener("click", function () {
              if (self.vnnMenu?.classList.contains("in")) {
                self.vnnMenu.classList.remove("in");
                self.vnnMenu.setAttribute("aria-expanded", "false");
              }
            });

            this.vnnToggle?.addEventListener("click", function () {
              HeaderNav.close();
              HeaderNav.onClosed();
            });
        },

        closeMobileMenuClickOutside: function () {
            document.querySelector('.navbar-megamenu')?.addEventListener('click', function (e) {
                if (document.body.classList.contains("menu-open")) {
                    if (HeaderNav.toggle.classList.contains("open")) {
                        if (e.target.className === document.querySelector('.navbar-megamenu').className ||
                            e.target.className === document.querySelector('.navbar-header').className
                        ) {
                            HeaderNav.toggle.click();
                        }
                    }
                }
            });
        },
        closeSubMenu: function () {
            document.querySelectorAll(".navbar-megamenu .score-megamenu-dropdown.open > a").forEach(function (el) {
                el.setAttribute("aria-expanded", false);
            });
            document.querySelectorAll(".navbar-megamenu .score-megamenu-dropdown.open").forEach(function (el) {
                el.classList.remove("open");
            });
        },
        setupCloseSubMenu: function () {
            document.querySelectorAll(".navbar-megamenu .menu-back").forEach(function (el) {
                el.addEventListener("click", () => {
                    HeaderNav.closeSubMenu();
                });
            });

            document.querySelectorAll(".navbar-megamenu.score-megamenu .score-megamenu-dropdown").forEach(function (el) {
                if (el.querySelectorAll(".active").length > 0) {
                    el.classList.add("active");
                }
            });
        },
        clicked: function () {
            this.toggle?.addEventListener('click', function () {
                if (!this.classList.contains('open')) {
                    HeaderNav.open();
                } else {
                    HeaderNav.close();
                }
            });

            document.querySelectorAll("[data-toggle='collapse']:not(.navbar-toggle)").forEach(function (el) {
                el.addEventListener("click", () => {
                    HeaderNav.close();
                });
            });
        },
        open: function () {
            this.toggle.classList.add('open');
            this.header.classList.add('nav-open');
            this.header.classList.remove('nav-closed');
            document.body.classList.add("menu-open");
        },
        close: function () {
            this.toggle.classList.remove('open');
            this.header.classList.remove('nav-open');
            document.body.classList.remove("menu-open");
        },
        onClosed: function () {
            this.header?.classList.add("nav-closed");

            const header = document.querySelector('.score-header');
            const hasHeader = helper.isNotNullOrUndefined(header);
            if (hasHeader) {
                header.addEventListener('transitionend', () => {
                    if (!this.header.classList.contains("nav-open")) {
                        this.header.classList.add("nav-closed");
                    }
                });
            }
        },
        closePanel: function () {
            this.panelBtn.forEach(function (el) {
                el.addEventListener("click", () =>{
                    document.querySelectorAll('.collapse').forEach(function (collapseEl) {
                        collapseEl.classList.remove('show');
                    });
                    if (!el.classList.contains('return-focus')) {
                        HeaderNav.panelBtn.forEach(function (btn) {
                            btn.classList.remove('return-focus');
                        });
                        el.classList.add('return-focus');
                    } else {
                        HeaderNav.panelBtn.forEach(function (btn) {
                            btn.classList.remove('return-focus');
                        });
                    }
                });
            });
        },
        searchOpen: function () {
            const btnSearch = document.querySelector(".btn--search");
            const panelLanguage = document.querySelector('header > .score-stripe.score-stripe--collapsed:not(.score-stripe--search) .panel-collapse.container.collapse');
            btnSearch?.addEventListener("click", () => {
                panelLanguage.classList.remove("in");
                const isBtnAriaExpanded = btnSearch.getAttribute('aria-expanded') === 'true';
                const searchForm = document.querySelector('.tek-searchbox .form-control')
                const hasForm = helper.isNotNullOrUndefined(searchForm);
                if (isBtnAriaExpanded && hasForm) {
                    searchForm.focus();
                } 
            });

        },
        langOpen: function () {
            const btnLanguage = document.querySelector('.btn--language');
            const searchPanel = document.querySelector('.score-stripe--search .panel-collapse.container.collapse'); 
            btnLanguage?.addEventListener("click", () => {
                searchPanel.classList.remove("in");
                setTimeout(function () {
                    const isBtnAriaExpanded = btnLanguage.getAttribute('aria-expanded') === 'true';
                    if (isBtnAriaExpanded) {
                        btnLanguage.setAttribute('tabindex', '-1');
                    } else {
                        btnLanguage.removeAttribute('tabindex');
                        btnLanguage.focus();
                    }
                }, 100);
            });
        },
        panelBtnClose: function () {
            this.closeBtn.forEach(function (el) {
                el.addEventListener("click", () => {
                    const returnFocus = document.querySelector('.return-focus');
                    const hasReturnFocus = helper.isNotNullOrUndefined(returnFocus);
                    if (hasReturnFocus) {
                        returnFocus.focus();
                        returnFocus.classList.remove('return-focus');
                    }
                });
            });
        },
        generateListItem: function () {
            const nav = this.header?.querySelector('.navbar-nav > .nav');
            const hasNav = helper.isNotNullOrUndefined(nav);
            if (hasNav) {
                const listItem = document.createElement('li');
                listItem.className = 'nav-1';
                nav.parentNode.insertBefore(listItem, nav);
                listItem.appendChild(nav);
            }
        }
    };

    return HeaderNav;
});

